
// // client/src/components/tenant/TenantUsers.jsx
// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { listTenantUsers, setUserActive } from '../../services/tenantUsersApi';
// import AppFooter from '../AppFooter';
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaSave, FaList, FaTasks, FaShare,FaEnvelope } from 'react-icons/fa';

// export default function TenantUsers() {
//   const { tenant } = useParams();
//   const tenantNum = Number(tenant) || null;
//   const navigate = useNavigate();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState(null);
//   const [saving, setSaving] = useState({}); // { [userId]: true }

//   const refresh = async () => {
//     if (!tenantNum) return;
//     setLoading(true);
//     setErr(null);
//     try {
//       const data = await listTenantUsers(tenantNum);
//       setRows(data);
//     } catch (e) {
//       setErr(e.message || 'Failed to load users');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDashboard = () => {
//     navigate(`/${tenant}/dashboard`);
//   };

//   useEffect(() => {
//     setRows([]);
//     if (tenantNum) refresh();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [tenantNum]);

//   const toggleActive = async (e, u) => {
//     e.stopPropagation(); // don’t navigate when clicking the button
//     const next = u.active ? 0 : 1;
//     setSaving(s => ({ ...s, [u.id]: true }));
//     setRows(prev => prev.map(r => (r.id === u.id ? { ...r, active: next } : r)));
//     try {
//       await setUserActive(tenantNum, u.id, next);
//     } catch (e2) {
//       setRows(prev => prev.map(r => (r.id === u.id ? { ...r, active: u.active } : r)));
//       alert(e2.message || 'Failed to update user');
//     } finally {
//       setSaving(s => {
//         const n = { ...s };
//         delete n[u.id];
//         return n;
//       });
//     }
//   };

//   if (!tenantNum) {
//     return (
//       <div className="container">
//         <div className="alert alert-warning mt-3">
//           Missing tenant id. Route should be <code>/:tenant/tenantUsers</code>.
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container">{/* container keeps width ≤ viewport */}
//       <div className="d-flex align-items-center justify-content-between mb-3">
//         <h3 className="hdr hdr--primary hdr--lg">Users</h3>
//         <button className="btn btn-secondary" disabled={loading} onClick={refresh}>Refresh</button>
//       </div>

//       {err && <div className="alert alert-danger">{err}</div>}

//       <div className="table-responsive">
//         <table
//           className="table table-sm align-middle w-100"
//           style={{ tableLayout: 'fixed' }}
//         >
//           <thead style={{ backgroundColor: '#01057a', color: '#fff' }}>
//             <tr>
//               <th style={{ width: '50%' }}>Name</th>
//               <th style={{ width: '25%' }}>Username</th>
//               <th style={{ width: '15%' }} className="text-center">Active</th>
//               <th style={{ width: '10%' }} />
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map(u => {
//               const name =
//                 u.displayName ||
//                 [u.firstname, u.lastname].filter(Boolean).join(' ') ||
//                 u.username ||
//                 '(no name)';

//               return (
//                 <tr
//                   key={u.id}
//                 //   onClick={() => navigate(`/${tenant}/users/${u.id}`)}
//                 onClick={() => navigate(`/${tenant}/${u.id}/user`)}
//                   style={{ cursor: 'pointer' }}
//                 >
//                   <td className="text-truncate" title={name}>{name}</td>
//                   <td className="text-truncate">{u.username}</td>
//                   <td className="text-center">
//                     <span className={`badge ${u.active ? 'bg-success' : 'bg-secondary'}`}>
//                       {u.active ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td className="text-end">
//                     <button
//                       className={`btn ${u.active ? 'btn-warning' : 'btn-primary'} btn-sm`}
//                       disabled={!!saving[u.id]}
//                       onClick={(e) => toggleActive(e, u)}
//                     >
//                       {saving[u.id] ? 'Saving…' : (u.active ? 'Set Inactive' : 'Set Active')}
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//             {!loading && rows.length === 0 && (
//               <tr><td colSpan="4" className="text-muted">No users found.</td></tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//         <AppFooter
//         buttons={[
//           {
//             icon: <FaTimes />,
//             label: 'Cancel',
//             onClick: handleDashboard,
//           },
//           // {
//           //   icon: <FaPlus />,
//           //   label: 'Create',
//           //   onClick: registerUser,
//           //   type: 'submit'
//           // },
//         ]}
//       />
//       {loading && <div className="text-muted">Loading…</div>}
//     </div>
//   );
// }


// client/src/components/tenant/TenantUsers.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { listTenantUsers, setUserActive } from "../../services/tenantUsersApi";
import AppFooter from "../AppFooter";
import { FaTimes, FaSync, FaHome, FaUserPlus } from "react-icons/fa";

export default function TenantUsers() {
  const { tenant } = useParams();
  const tenantNum = Number(tenant) || null;
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [saving, setSaving] = useState({}); // { [userId]: true }

  const refresh = async () => {
    if (!tenantNum) return;
    setLoading(true);
    setErr(null);
    try {
      const data = await listTenantUsers(tenantNum);
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e.message || "Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  const handleDashboard = () => {
    navigate(`/${tenant}/dashboard`);
  };

  useEffect(() => {
    setRows([]);
    if (tenantNum) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantNum]);

  const toggleActive = async (e, u) => {
    e.stopPropagation(); // don’t navigate when clicking the button
    const next = u.active ? 0 : 1;

    setSaving((s) => ({ ...s, [u.id]: true }));
    // optimistic UI update
    setRows((prev) =>
      prev.map((r) => (r.id === u.id ? { ...r, active: next } : r))
    );

    try {
      await setUserActive(tenantNum, u.id, next);
    } catch (e2) {
      // revert on error
      setRows((prev) =>
        prev.map((r) => (r.id === u.id ? { ...r, active: u.active } : r))
      );
      alert(e2.message || "Failed to update user");
    } finally {
      setSaving((s) => {
        const n = { ...s };
        delete n[u.id];
        return n;
      });
    }
  };

  if (!tenantNum) {
    return (
      <div className="container py-3">
        <div className="alert alert-warning mt-3">
          Missing tenant id. Route should be <code>/:tenant/tenantUsers</code>.
        </div>
      </div>
    );
  }

  const hasUsers = rows.length > 0;

  return (
    <div className="container py-3">
      {/* Header – same style as ScheduledPostsList */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Users</h5>
        </div>
        {/* <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          disabled={loading}
          onClick={refresh}
        >
          <FaSync className={loading ? "fa-spin me-1" : "me-1"} />
          Refresh
        </button> */}
      </div>

      {/* Error banner */}
      {!!err && (
        <div className="alert alert-danger" role="alert">
          <strong>Error:</strong> {err}
        </div>
      )}

      {/* Loading state */}
      {loading && !hasUsers && (
        <div className="text-center text-muted py-4">
          Loading users…
        </div>
      )}

      {/* Empty state */}
      {!loading && !hasUsers && !err && (
        <div className="text-center text-muted py-4">
          No users found for this tenant.
        </div>
      )}

      {/* User list – card style like ScheduledPostsList */}
      {hasUsers && (
        <div className="list-group mb-3" style={{ background: "#3C3C3C", borderRadius: 8, padding: 6 }}>
          {rows.map((u) => {
            const name =
              u.displayName ||
              [u.firstname, u.lastname].filter(Boolean).join(" ") ||
              u.username ||
              "(no name)";
            const active = !!u.active;

            return (
              <div
                key={u.id}
                className="list-group-item mb-2 rounded shadow-sm"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/${tenant}/${u.id}/user`)}
              >
                <div className="d-flex justify-content-between align-items-start">
                  {/* Left side – main info */}
                  <div style={{ textAlign: "left", minWidth: 0, flex: "1 1 0%" }}>
                    <div className="fw-semibold text-truncate" style={{ color: "#212529" }}>{name}</div>
                    <div className="small text-truncate" style={{ color: "#6c757d" }}>
                      {u.username || "No username"}
                    </div>
                    {u.email && (
                      <div className="small text-truncate" style={{ color: "#6c757d" }}>{u.email}</div>
                    )}
                    {u.role && (
                      <div className="small text-truncate" style={{ color: "#6c757d" }}>{u.role}</div>
                    )}
                  </div>

                  {/* Right side – status + toggle */}
                  <div
                    className="d-flex flex-column align-items-end"
                    style={{ gap: "0.25rem", flexShrink: 0, marginLeft: "0.5rem" }}
                  >
                    <span
                      className={`badge ${
                        active ? "bg-success" : "bg-secondary"
                      }`}
                    >
                      {active ? "Active" : "Inactive"}
                    </span>
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        active ? "btn-warning" : "btn-primary"
                      }`}
                      disabled={!!saving[u.id]}
                      onClick={(e) => toggleActive(e, u)}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {saving[u.id]
                        ? "Saving…"
                        : active
                        ? "Set Inactive"
                        : "Set Active"}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Footer – same pattern as other screens */}
      <AppFooter
        buttons={[
          {
            icon: <FaHome />,
            label: "Home",
            onClick: handleDashboard,
          },
          {
            icon: <FaUserPlus />,
            label: "Add User",
            onClick: () => navigate(`/${tenant}/userAdd`),
          },
        ]}
      />
    </div>
  );
}
